module.exports = __webpack_public_path__ + "img/7.4ac07428.jpg";